module.exports = __webpack_public_path__ + "static/media/SouthWesternTimes-devicecomp-min.bab19af9.webp";